import {PAYMENT_METHOD_ACTION, PaymentMethodAction} from '../action/payment-method.action';
import {IPaymentMethodState} from '../state/payment-method.state';

const initialPaymentMethod: IPaymentMethodState = {
  paymentMethod: null,
};

export function paymentMethodReducer(
  state: IPaymentMethodState = initialPaymentMethod,
  action: PaymentMethodAction,
): IPaymentMethodState {
  switch (action.type) {
    case PAYMENT_METHOD_ACTION.INIT_PAYMENT_METHOD:
      return {
        ...state,
        ...action.payload,
      };
    case PAYMENT_METHOD_ACTION.DELETE_PAYMENT_METHOD:
      return initialPaymentMethod;
    case PAYMENT_METHOD_ACTION.RESET_PAYMENT_METHOD:
      return initialPaymentMethod;
    default:
      return state;
  }
}
